module.exports = __webpack_public_path__ + "5d942e50afb28b38a2afd94012a10a6c.jpg";


//////////////////
// WEBPACK FOOTER
// ./public/content/assets/slideshow_04_mobile.jpg
// module id = 655
// module chunks = 0